module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "persistent": "",
      "width": "380px"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline py-2 px-4"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": ""
    }
  }, [_c('p', {
    staticClass: "headline-title"
  }, [_vm._v("\n\t\t\t\t\t\tNo-show de reserva\n\t\t\t\t\t")])])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-4"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('label', {
    staticClass: "headline-label"
  }, [_vm._v("\n\t\t\t\t\t\tBooking ID:\n\t\t\t\t\t")]), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.model.code) + "\n\t\t\t\t")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('label', {
    staticClass: "headline-label"
  }, [_vm._v("\n\t\t\t\t\t\tNombre:\n\t\t\t\t\t")]), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.getPropValue(_vm.model, 'data', 'name')) + "\n\t\t\t\t\t" + _vm._s(_vm.getPropValue(_vm.model, 'data', 'lastname')) + "\n\t\t\t\t")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "mt-2": ""
    }
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("No-show")]), _vm._v(" "), _c('select-date', {
    attrs: {
      "icon": "event"
    },
    model: {
      value: (_vm.model.bookingDate),
      callback: function($$v) {
        _vm.model.bookingDate = $$v
      },
      expression: "model.bookingDate"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-3": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "input-checkbox input-booking",
    attrs: {
      "label": "Facturar",
      "color": "info",
      "hide-details": ""
    },
    model: {
      value: (_vm.model.flagBilling),
      callback: function($$v) {
        _vm.model.flagBilling = $$v
      },
      expression: "model.flagBilling"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "pr-2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-cancel grey",
    nativeOn: {
      "click": function($event) {
        _vm.closeBookingModal($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tCancelar\n\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "pl-2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-save",
    nativeOn: {
      "click": function($event) {
        _vm.noShowBooking($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tAceptar\n\t\t\t\t\t")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-874d0400","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/bookings/sub-component/MenuNoShow.vue
// module id = 1681
// module chunks = 21